import { isIos } from "../constants";

enum FontWeight {
    Thin = 100,
    ExtraLight = 200,
    Light = 300,
    Regular = 400,
    Medium = 500,
    SemiBold = 600,
    Bold = 700,
    ExtraBold = 800,
  }
  

export const font = {
        [FontWeight.Light]:
          isIos ? 'IRANYekanFN-Light' : 'IRANYekanThin',
        [FontWeight.Regular]: isIos ? 'IRANYekanFN' : 'IRANYekan',
        [FontWeight.Medium]:
        isIos ? 'IRANYekanFN-Medium' : 'IRANYekanMedium',
        [FontWeight.SemiBold]:
        isIos ? 'IRANYekanFN-ExtraBold' : 'IRANYekanBold',
        [FontWeight.Bold]:
        isIos ? 'IRANYekanFN-ExtraBold' : 'IRANYekanBold',
}